import React, { ReactElement } from 'react';
import { ConfirmActionContext, ModalDialogueContext, ModalDialogueWindow } from 'idsk-react-components';
import { ResponsiveContext } from 'slovlex-idsk-react-components';
import ElegislativaRouter from './routing/ElegislativaRouter';
import { SuccessMessageContextProvider } from './context/SuccessMessageContext';
import { ClientStatusContextProvider } from './context/ClientStatusContext';
import './main.scss';
import { SecurityContextProvider } from './context/SecurityContext';
import { PracovnyKrokLegislativnyMaterialContextProvider } from './context/PracovnyKrokLegislativnyMaterialContext';
import { UserContextProvider } from './context/UserContext';
import PodpisPredsedaContextProvider
  from './context/PodpisPredsedaFormDataContext/PodpisPredsedaFormDataContextProvider';
import HistoryPageContextProvider from './context/BreadcrumbContext';

const App = (): ReactElement => (
  <ModalDialogueContext>
    <ResponsiveContext maxDesktopValuePx={640}>
      <SuccessMessageContextProvider>
        <ModalDialogueWindow />
        <SecurityContextProvider>
          <ClientStatusContextProvider>
            <ConfirmActionContext>
              <UserContextProvider>
                <PracovnyKrokLegislativnyMaterialContextProvider>
                  <PodpisPredsedaContextProvider>
                    <HistoryPageContextProvider>
                      <ElegislativaRouter />
                    </HistoryPageContextProvider>
                  </PodpisPredsedaContextProvider>
                </PracovnyKrokLegislativnyMaterialContextProvider>
              </UserContextProvider>
            </ConfirmActionContext>
          </ClientStatusContextProvider>
        </SecurityContextProvider>
      </SuccessMessageContextProvider>
    </ResponsiveContext>
  </ModalDialogueContext>
);

export default App;
